import { CompanyReportType } from '../../CompanyReport';
import { RecurringCompanyReport } from '../../RecurringCompanyReport';
import { Timezone } from '../../Time';
import { EDITED_REPORT_DELIVERY_HOUR } from '../EditedReportDeliveryHour';

export const MI_TIMEZONE: Timezone = 'America/New_York' as const;

// Day 20 sits inside the 16th-24th ADR production window with margin before the 25th deadline.
// The window absorbs weekends/holidays, so no business-day adjustment is applied.
export const MI_DEFAULT_RECURRING_REPORT_VALUES: Record<
  CompanyReportType.ADR | CompanyReportType.ADR_EDIT,
  Pick<RecurringCompanyReport, 'deliveryHour' | 'deliveryTimeZone' | 'title'> & { deliveryDay: number }
> = {
  ADR: {
    deliveryHour: 6,
    deliveryTimeZone: MI_TIMEZONE,
    title: 'MI ADR',
    deliveryDay: 20,
  },
  ADR_EDIT: {
    deliveryHour: EDITED_REPORT_DELIVERY_HOUR,
    deliveryTimeZone: MI_TIMEZONE,
    title: 'MI ADR (Edits)',
    // 0 is the repo-wide convention for a report that is not scheduled by day of month: edit
    // reports run on `editedReportSchedule`. Never feed this to `DateTime.set({ day })`.
    deliveryDay: 0,
  },
} as const;
